import { useState } from 'react'
import { useHubLang } from '../lib/i18n'
import { PHOTO_WHAT } from '../lib/hubCopy'

/**
 * 305 (FED-72). The one place a reason is asked for — when somebody says a
 * tag is NOT in a photo, and when they add a tag One did not suggest. David,
 * 22 Oct: "when they reject a tag, give them an option to suggest why
 * (especially if it was a high probability tag that was wrong)".
 *
 * Optional, always: Send without a reason is one press. The prompt changes
 * with the case — a no on a tag One was sure of asks what gave it away; an
 * added tag asks what shows it. 280 characters, as the database allows, and
 * the reason goes to the poster, the Gallery roles and (when it agrees with
 * where the tag ends up) to One — the dialog says so, once, in the line
 * under the box.
 */
export function TagReason({
  kind,
  label,
  confidence,
  busy,
  onSend,
  onCancel,
}: {
  kind: 'no' | 'add'
  label: string
  /** One's confidence (0..1) for a no on One's own suggestion; null otherwise. */
  confidence: number | null
  busy: boolean
  onSend: (reason: string | null) => void
  onCancel: () => void
}) {
  const t = PHOTO_WHAT[useHubLang()]
  const [text, setText] = useState('')
  const sure = kind === 'no' && confidence !== null && confidence >= 0.7
  const prompt = kind === 'add' ? t.whyAdd(label) : sure ? t.whyNoSure(label, Math.round(confidence! * 100)) : t.whyNo(label)
  return (
    <div className="tagreason" role="group" aria-label={prompt}>
      <p className="tagreason__prompt">{prompt}</p>
      <textarea
        className="tagreason__box"
        rows={2}
        maxLength={280}
        value={text}
        placeholder={t.reasonPlaceholder}
        onChange={(e) => setText(e.target.value)}
        disabled={busy}
      />
      <p className="tagreason__note">{t.reasonNote}</p>
      <div className="tagreason__actions">
        <button type="button" className="btn btn--primary btn--sm" disabled={busy} onClick={() => onSend(text.trim() || null)}>
          {text.trim() ? t.send : t.skipReason}
        </button>
        <button type="button" className="btn btn--quiet btn--sm" disabled={busy} onClick={onCancel}>
          {t.cancel}
        </button>
      </div>
    </div>
  )
}
